import type { AxiosRequestConfig } from "axios";
import { api } from "../utils/axios";

type RequestOptions = { token?: string | null };

export type FloorPlanSection = { id: string; name: string; color: string };

export type FloorPlanResponse = {
  success: true;
  restaurantId: string;
  sections: Array<{
    _id: string;
    restaurantId: string;
    name: string;
    description?: string;
    color?: string;
    isActive: boolean;
    isArchived?: boolean;
  }>;
  tables: Array<{
    _id: string;
    restaurantId: string;
    sectionId: string;
    name: string;
    capacity: number;
    combinableWith?: string[];
    notes?: string;
    isActive?: boolean;
    isArchived?: boolean;
    layout?: {
      position?: { x: number; y: number };
      size?: { width: number; height: number };
      rotation?: number;
      locked?: boolean;
      zIndex?: number;
      shape?: "circle" | "square" | "rectangle";
    };
  }>;
};

const withAuth = (options?: RequestOptions): AxiosRequestConfig => {
  if (!options?.token) return { withCredentials: true };

  return {
    withCredentials: true,
    headers: {
      Authorization: `Bearer ${options.token}`,
    },
  };
};

const base = (restaurantId: string) => `/api/reservations/${restaurantId}/floor-plan`;

export const getFloorPlan = async (restaurantId: string, options?: RequestOptions): Promise<FloorPlanResponse> => {
  const response = await api.get<FloorPlanResponse>(base(restaurantId), withAuth(options));
  return response.data;
};

export const putFloorPlan = async (
  restaurantId: string,
  payload: { sections?: Array<Record<string, unknown>>; tables?: Array<Record<string, unknown>> },
  options?: RequestOptions
): Promise<FloorPlanResponse> => {
  const response = await api.put<FloorPlanResponse>(base(restaurantId), payload, withAuth(options));
  return response.data;
};

export const patchFloorPlan = async (
  restaurantId: string,
  patch: { sections?: Array<Record<string, unknown>>; tables?: Array<Record<string, unknown>> },
  options?: RequestOptions
): Promise<FloorPlanResponse> => {
  const response = await api.patch<FloorPlanResponse>(base(restaurantId), patch, withAuth(options));
  return response.data;
};
